import { OrganizationSettings } from "~/components/admin/organization/organization-settings";

export const ScreenOrganizationSettings = () => <OrganizationSettings />;
